import { postRestURL } from "../utils/constants/constants";

export async function getLanguages() {
    try {
        const response = await fetch(`${postRestURL}/language?select=id,name,nombre,convention`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getAgeRange() {
    try {
        const response = await fetch(`${postRestURL}/agerange?select=id,range`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCategories() {
    try {
        const response = await fetch(`${postRestURL}/category?order=ordercategory`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCountries() {
    try {
        const response = await fetch(`${postRestURL}/country?order=ordercountry`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getPriceRange() {
    try {
        const response = await fetch(`${postRestURL}/price?order=id`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getNetworks() {
    try {
        const response = await fetch(`${postRestURL}/socialnetwork?order=ordernetwork&deleted=eq.0`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}